import React from "react";
import { Select } from "react-materialize";
import Html from "utils/Html";
import Func from "utils/Func";
import { useNotify } from "context/NotifyContext";

export default function SelectLimit() {
  const { filters, storeFilters } = useNotify();
  const handleEvents = {
    OnChange: function (evt) {
      storeFilters({
        ...filters,
        limit: evt.target.value,
        page: 1,
        keyChange: Func.GetKeyRandom(),
      });
    },
  };

  let optionData = [];
  optionData.push({ name: 10, value: 10 });
  optionData.push({ name: 20, value: 20 });
  optionData.push({ name: 30, value: 30 });

  return (
    <div
      key="btn-select-limit-row"
      id="btn-select-limit-row"
      style={{ marginRight: "0px" }}
    >
      <Select
        label=""
        multiple={false}
        id="select-limit-row"
        name="limit-row"
        options={{
          classes: "",
          dropdownOptions: {
            alignment: "left",
            autoTrigger: true,
            closeOnClick: true,
            constrainWidth: true,
            coverTrigger: true,
            hover: false,
            inDuration: 150,
            onCloseEnd: null,
            onCloseStart: null,
            onOpenEnd: null,
            onOpenStart: null,
            outDuration: 250,
          },
        }}
        defaultValue={filters.limit}
        onChange={handleEvents.OnChange}
      >
        <Html.Options data={optionData} addon={{ key: "limit-row" }} />
      </Select>
    </div>
  );
}
